import React from 'react';
import { Footer } from 'antd/es/layout/layout';
import { VERSION } from '../../resources/constant';

const FooterLayout = () => {
  return <Footer style={{ textAlign: 'center' }}>ZettaSoft @2023 version {VERSION}</Footer>;
};

export default FooterLayout;
